import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=e9580d9a&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=e9580d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9580d9a",
  null
  
)

export default component.exports